export type PaymentProviderCapability = 'DepositPayments' | 'CancellationChargePayments' | 'VoucherPayments'

export type PaymentGateway = 'stripe' | 'breathepay' | 'ryftpay' | 'dojo' | 'tablesense-test' | 'teya';

export class ApplePayWebDomain {
    constructor(
        public id: string,
        public domain: string
    ) { }
}

export class PaymentsAccount {
    constructor(
        public id: string,
        public currencyCode: string,
        public depositApplicationFeePercent: number,
        public cancellationChargeApplicationFeePercent: number,
        public voucherApplicationFeePercent: number,
        public processingFeePercent: number | null,
        public processingFeeUnitAmount: number | null,
        public gateway: PaymentGateway,
        public apiKey: string | null,
        public applePayWebDomains: ApplePayWebDomain[] = [],
        public applePayEnabled: boolean = false,
        public active: boolean = true,
        public dateDisconnected: Date | null = null,
        public capabilities: PaymentProviderCapability[] = PaymentsAccount.capabilitiesForGateway(gateway),
        public orderApplicationFeePercent: number = depositApplicationFeePercent
    ) { }

    get isConnected(): boolean {
        return this.dateDisconnected === null
    }

    get orderApplicationFeePercentage(): number {
        return this.orderApplicationFeePercent / 10000
    }

    get depositApplicationFeePercentage(): number {
        return this.depositApplicationFeePercent / 10000
    }

    get cancellationChargeApplicationFeePercentage(): number {
        return this.cancellationChargeApplicationFeePercent / 10000
    }

    get voucherApplicationFeePercentage(): number {
        return this.voucherApplicationFeePercent / 10000
    }

    get processingFeePercentage(): number | null {
        return this.processingFeePercent === null ? null : this.processingFeePercent / 10000
    }

    get hasOwnProcessingFee(): boolean {
        return this.processingFeePercent !== null && this.processingFeeUnitAmount !== null
    }

    get applePayConfigurable(): boolean {
        return this.usesRyft();
    }

    usesStripe(): boolean {
        return this.gateway === 'stripe';
    }

    usesBreathe(): boolean {
        return this.gateway === 'breathepay';
    }

    usesRyft(): boolean {
        return this.gateway === 'ryftpay';
    }

    usesTeya(): boolean {
        return this.gateway === 'teya'
    }

    usesDojo(): boolean {
        return this.gateway === 'dojo'
    }

    supports(capability: PaymentProviderCapability): boolean {
        return this.capabilities.includes(capability)
    }

    static capabilitiesForGateway(gateway: PaymentGateway): PaymentProviderCapability[] {
        return ['dojo', 'teya', 'tablesense-test'].includes(gateway)
            ? ['DepositPayments', 'CancellationChargePayments']
            : ['DepositPayments', 'CancellationChargePayments', 'VoucherPayments']
    }
}
